import { createAction } from 'redux-actions';

import { CLEAR, CLOSE, OPEN } from './actionTypes';
import { ERROR } from './constants';

export const open = createAction(OPEN, (name, title = null, type = ERROR) => ({ name, title, type }));

export const close = createAction(CLOSE, (name) => ({ name }));

export const clear = createAction(CLEAR);

export default {
	open,
	close,
	clear,
};
